import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getAll as getBlockList } from 'actions/block';

class ActivityBlockCreation extends Component {
  static propTypes = {
    blocks: PropTypes.shape({}),
    actions: PropTypes.shape({}).isRequired,
    setBlockData: PropTypes.func.isRequired,
    setBlockDataList: PropTypes.func,
    chapterCode: PropTypes.string,
    programId: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      blockDataList: {},
    };
  }

  componentDidMount() {
    const { getBlockList } = this.props.actions;
    const { programId, chapterCode } = this.props;

    getBlockList({
      query: '',
      program_id: programId,
      chapter_code: chapterCode,
    });
  }

  getAllData = () => {
    const { actions, programId, chapterCode } = this.props;
    const { getBlockList } = actions;

    getBlockList({
      query: '',
      program_id: programId,
      chapter_code: chapterCode,
    });
    this.forceUpdate();
  };

  static getDerivedStateFromProps(
    { blocks, programId, chapterCode, setBlockDataList, fromSheets },
    prevState,
  ) {
    let newState = {};

    if (blocks) {
      let blockList = store.getAll(blocks, {
        query: prevState.searchTerm,
        program_id: programId,
        chapter_code: chapterCode,
      });

      if (prevState.blockDataList && prevState.blockDataList !== blockList.data) {
        newState['blockDataList'] = blockList.data;
      }

      if (fromSheets) {
        setBlockDataList(newState.blockDataList);
      }

      return newState;
    }
    return null;
  }

  render() {
    return null;
  }
}

export default connect(
  ({ blocks }) => ({
    blocks: blocks,
  }),
  dispatch => ({
    actions: bindActionCreators({ getBlockList }, dispatch),
  }),
)(ActivityBlockCreation);
